import Utils from "../utils/Utils";

const getAuth = ({ jwt, Authorization } = {}) => jwt || Authorization || "";

const addParam = (params, key, value) => {
  if (value !== undefined && value !== null && value !== "") {
    params.append(key, value);
  }
};

const vendorWalletController = {
  addFunds: ({ Authorization, jwt, request } = {}) => {
    return Utils.controller(
      "api/wallet/v1/addFunds",
      request,
      "POST",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  approveWithdrawal: ({ Authorization, jwt, request } = {}) => {
    return Utils.controller(
      "api/wallet/v1/approveWithdrawal",
      request,
      "POST",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  getWallet: ({
    Authorization,
    jwt,
    companyId,
    dateFrom,
    dateTo,
    page,
    search,
    size,
    transactionType,
  } = {}) => {
    const params = new URLSearchParams();

    addParam(params, "companyId", companyId);
    addParam(params, "dateFrom", dateFrom);
    addParam(params, "dateTo", dateTo);
    addParam(params, "page", page);
    addParam(params, "search", search);
    addParam(params, "size", size);
    addParam(params, "transactionType", transactionType);

    return Utils.controller(
      "api/wallet/v1/getWallet",
      "",
      "GET",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  getWalletTransactions: ({
    Authorization,
    jwt,
    dateFrom,
    dateTo,
    page,
    search,
    size,
    transactionType,
    type,
    walletId,
  } = {}) => {
    const params = new URLSearchParams();

    addParam(params, "dateFrom", dateFrom);
    addParam(params, "dateTo", dateTo);
    addParam(params, "page", page);
    addParam(params, "search", search);
    addParam(params, "size", size);
    addParam(params, "transactionType", transactionType);
    addParam(params, "type", type);
    addParam(params, "walletId", walletId);

    return Utils.controller(
      "api/wallet/v1/getWalletTransactions",
      "",
      "GET",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  getWithdrawalRequests: ({
    Authorization,
    jwt,
    dateFrom,
    dateTo,
    page,
    search,
    size,
    status,
    type,
    walletId,
  } = {}) => {
    const params = new URLSearchParams();

    addParam(params, "dateFrom", dateFrom);
    addParam(params, "dateTo", dateTo);
    addParam(params, "page", page);
    addParam(params, "search", search);
    addParam(params, "size", size);
    addParam(params, "status", status);
    addParam(params, "type", type);
    addParam(params, "walletId", walletId);

    return Utils.controller(
      "api/wallet/v1/getWithdrawalRequests",
      "",
      "GET",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  rejectWithdrawal: ({ Authorization, jwt, request } = {}) => {
    return Utils.controller(
      "api/wallet/v1/rejectWithdrawal",
      request,
      "POST",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  withdraw: ({ Authorization, jwt, request } = {}) => {
    return Utils.controller(
      "api/wallet/v1/withdraw",
      request,
      "POST",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },
};

export default vendorWalletController;
